import axios from 'axios';
import { parseStreamRetryAfterMs } from './idempotency';

const SAFE_READ_RETRY_DELAY_MS = 250;
const MAX_SAFE_READ_RETRY_DELAY_MS = 1000;

/** Retry one failed read once; never retry a policy rejection or a mutation. */
export async function retrySafeRead<T>(read: () => Promise<T>): Promise<T> {
  try {
    return await read();
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response?.status;
    const transientHttp = status === 408 || (typeof status === 'number' && status >= 500);
    const transientNetwork = axios.isAxiosError(error)
      && !error.response
      && ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error.code || '');
    if (!transientHttp && !transientNetwork) throw error;
    const retryAfter = (error as { response?: { headers?: Record<string, unknown> } })?.response?.headers?.['retry-after'];
    const delay = parseStreamRetryAfterMs(typeof retryAfter === 'string' ? retryAfter : null)
      ?? SAFE_READ_RETRY_DELAY_MS;
    if (delay > MAX_SAFE_READ_RETRY_DELAY_MS) throw error;
    await new Promise<void>((resolve) => window.setTimeout(resolve, delay));
    return read();
  }
}
